module.exports = __webpack_public_path__ + "static/media/czy_logo.dfda6eee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/czy_logo.svg
// module id = 869
// module chunks = 0